import React from 'react'
import Button from './button'
import { useTranslation } from 'react-i18next';

const TitleHeading = ({ heading, subHeading, triggerOldStatusAction, isShow = false }) => {
    const { t } = useTranslation();
  
  return (
    <>
      <div className='d-flex justify-content-between'>
        <div className="jana_authheading">
          <h3 className="mb-0">{heading}</h3>
          <p className="authpara mt-0">{subHeading}</p>
        </div>
        {isShow && (<>
          <div class="light-background-container">
            <Button
              buttonType="button"
              buttonName={t("OldApplicatonPortal")}
              buttonStyle="view-details-btn mx-0 bg-dark-red"
              handleClick={triggerOldStatusAction}
            />
          </div>
        </>)}
      </div>

    </>
  )
}

export default TitleHeading
